// extracted by mini-css-extract-plugin
export default {"mainImage":"home_mainImage__Ty5aE","bottomSheet":"home_bottomSheet__7r00c","fadeIn":"home_fadeIn__TXqgb"};